<template>
    <ul>
        <li class="stats-block" v-for="(stat, index) in stats" :key="index">
            <a :href="stat.listingUrl">
                <h3 class="stats-title">{{ stat.label }}</h3>
                <ul>
                    <li class="data-block-number inline-block">
                        <h3 class="data-value">{{ stat.count }}</h3>
                        <p class="data-label">{{ stat.labelCount }}</p>
                    </li>
                    <li class="data-block-number inline-block">
                        <h3 class="data-value">{{ $filters.numberFormat(stat.amount, true) }}</h3>
                        <p class="data-label">
                            {{ stat.labelAmount ? stat.labelAmount : $l10n.__('Montant') }}
                        </p>
                    </li>
                </ul>
            </a>
        </li>
    </ul>
</template>

<script>
export default {
    props: {
        data: {
            type: Object,
        },
    },

    data() {
        return {};
    },

    computed: {
        stats() {
            let stats = {};
            if (this.data.stats && Object.keys(this.data.stats).length > 0) {
                _.each(this.data.stats, (stat, index) => {
                    if (
                        this.data.labels &&
                        Object.keys(this.data.labels).length > 0 &&
                        this.data.labels[index]
                    ) {
                        stats[index] = { ...this.data.stats[index], ...this.data.labels[index] };
                    }
                });
            }
            return stats;
        },
    },
};
</script>
